import React from 'react';
import { Link } from 'react-router-dom';

export const getPageLinks = (id: string, closeTabs: () => void) => ({
  link_contact: <Link to={`./contact?id=${id}`} onClick={closeTabs} />,
  link_cookies: <Link to={`./cookies?id=${id}`} onClick={closeTabs} />,
  link_privacy: <Link to={`./privacy?id=${id}`} onClick={closeTabs} />,
  link_terms: <Link to={`./terms?id=${id}`} onClick={closeTabs} />,
  link_use: <Link to={`./acceptable-use?id=${id}`} onClick={closeTabs} />
});
